import React from 'react';
import { TableRow, TableCell } from '@mui/material';

const UserUsageItem = ({
  revenue_date,
  direct_sent,
  messages_sent,
  reminders_sent,
  replies_sent,
  binary_sent,
  premium_sent,
  total,
  user_name,
  costCenter,
}) => (
  <TableRow>
    <TableCell align="left">{costCenter || 'Missing (old replies)'}</TableCell>
    <TableCell>{user_name}</TableCell>
    <TableCell sx={{ whiteSpace: 'nowrap' }}>{revenue_date}</TableCell>
    <TableCell>{direct_sent}</TableCell>
    <TableCell>{messages_sent}</TableCell>
    <TableCell>{reminders_sent}</TableCell>
    <TableCell>{replies_sent}</TableCell>
    <TableCell>{premium_sent}</TableCell>
    <TableCell>{binary_sent}</TableCell>
    <TableCell>{total}</TableCell>
  </TableRow>
);

export default UserUsageItem;
